import { apiFetch } from './api';

const API_URL = import.meta.env.VITE_API_URL || '';

/**
 * O tipo diz o que o contato é para a empresa. O nome é editável, então nenhuma regra da tela
 * compara texto: quem manda no comportamento é `entraNoFunil`.
 */
export interface TipoContato {
    tipoContatoId: number;
    nome: string;
    comoReconhecer?: string | null;
    entraNoFunil: boolean;
    dataCriacao?: string;
}

export interface ApiResponse<T> {
    sucesso: boolean;
    mensagem: string;
    dados: T;
}

export interface SalvarTipoContatoDTO {
    nome: string;
    comoReconhecer?: string | null;
    entraNoFunil: boolean;
}

const json = { 'Content-Type': 'application/json' };

export const TipoContatoService = {
    getAll: async (): Promise<ApiResponse<TipoContato[]>> => {
        const response = await apiFetch(`${API_URL}/api/TipoContato/BuscarTodos`, { method: 'GET', headers: json });
        if (!response.ok) {
            // Lista vazia não é erro: é a empresa que ainda não cadastrou nada.
            if (response.status === 400 || response.status === 404) {
                return { sucesso: true, mensagem: 'Sem tipos de contato', dados: [] };
            }
            throw new Error('Erro ao buscar tipos de contato');
        }
        return response.json();
    },

    create: async (tipo: SalvarTipoContatoDTO): Promise<ApiResponse<TipoContato>> => {
        const response = await apiFetch(`${API_URL}/api/TipoContato/Criar`, {
            method: 'POST', headers: json, body: JSON.stringify(tipo),
        });
        if (!response.ok) throw new Error('Erro ao criar tipo de contato');
        return response.json();
    },

    update: async (id: number, tipo: SalvarTipoContatoDTO): Promise<ApiResponse<TipoContato>> => {
        const response = await apiFetch(`${API_URL}/api/TipoContato/Atualizar/${id}`, {
            method: 'PUT', headers: json, body: JSON.stringify(tipo),
        });
        if (!response.ok) throw new Error('Erro ao atualizar tipo de contato');
        return response.json();
    },

    delete: async (id: number): Promise<ApiResponse<unknown>> => {
        const response = await apiFetch(`${API_URL}/api/TipoContato/Deletar/${id}`, { method: 'DELETE', headers: json });
        if (!response.ok) throw new Error('Erro ao excluir tipo de contato');
        return response.json();
    },

    /** O botão da tela vazia: cria a lista sugerida de uma vez. */
    criarSugeridos: async (): Promise<ApiResponse<unknown>> => {
        const response = await apiFetch(`${API_URL}/api/TipoContato/CriarSugeridos`, { method: 'POST', headers: json });
        if (!response.ok) throw new Error('Erro ao criar os tipos sugeridos');
        return response.json();
    },

    /** Marca (ou limpa, com null) o tipo de um contato. */
    definirNoContato: async (contatoId: number, tipoContatoId: number | null): Promise<ApiResponse<unknown>> => {
        const response = await apiFetch(`${API_URL}/api/TipoContato/DefinirNoContato/${contatoId}`, {
            method: 'PUT', headers: json, body: JSON.stringify({ tipoContatoId }),
        });
        if (!response.ok) throw new Error('Erro ao definir o tipo do contato');
        return response.json();
    },
};
